import React, { useState } from "react";
import dynamic from "next/dynamic";

import { Button } from "@puzzle/ui";

import links from "lib/links";
import Analytics from "lib/analytics/analytics";

import { LaunchpadSource } from "../analytics";
import { useOnboardingProgress } from "../useOnboardingProgress";
import { BOOK_CALL_LABEL, BREX_TASKLIST_DESCRIPTION } from "../constants";
import { LeftSectionContentContainer } from "./LeftSectionContentContainer";

const DynamicPrimerDialog = dynamic(() => import("./PrimerDialog").then((mod) => mod.PrimerDialog));

export const BrexLaunchpadBannerContent = () => {
  const [showPrimerDialog, setShowPrimerDialog] = useState(false);
  const { showScheduleOnboardingCall } = useOnboardingProgress();
  return (
    <LeftSectionContentContainer description={BREX_TASKLIST_DESCRIPTION}>
      <Button
        variant="secondary"
        onClick={() => {
          setShowPrimerDialog(true);
        }}
      >
        Learn about Puzzle
      </Button>
      {showScheduleOnboardingCall && (
        <Button
          variant="primary"
          onClick={() => {
            window.open(links.freeConciergeOnboarding, "_blank");
            Analytics.onboardingCallCtaClicked({
              Source: LaunchpadSource.DashboardLaunchpadBanner,
            });
          }}
        >
          {BOOK_CALL_LABEL}
        </Button>
      )}
      {showPrimerDialog && (
        <DynamicPrimerDialog open={showPrimerDialog} onClose={() => setShowPrimerDialog(false)} />
      )}
    </LeftSectionContentContainer>
  );
};
